module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./NewAddressView.js"));
	}, "GiftNewAddressView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=GiftNewAddressView!./src/pages/Shop/GiftCheckOrder/NewAddress/NewAddressView.js
// module id = 1362
// module chunks = 418